import { useSelector } from "react-redux";
import Link from "next/link";
import styles from "./index.module.scss";
import Breadcrumbs from "../../../common/breadcrumbs";

export default function Empty() {
  const { cityName } = useSelector((state) => state.location);

  return (
    <div className="container">
      <Breadcrumbs />
      <div className={styles.Empty}>
        <h1>
          {cityName === "Россия" ? (
            <>Уважаемый клиент</>
          ) : (
            <>
              Уважаемый клиент, мы не оказываем услуги по установке и
              регистрации фаркопов и электрики в городе {cityName}
            </>
          )}
        </h1>
        <div>
          {cityName === "Россия" ? (
            <>
              Выберите ближайший к вам город для записи на установку или
              регистрации фаркопа:
            </>
          ) : (
            <>
              Мы работаем над открытием установочного центра в вашем городе, но
              вы можете выбрать ближайший к вам город для записи на установку
              или регистрации фаркопа:
            </>
          )}
        </div>
        <div className={styles.EmptyLinks}>
          <Link href={"https://spb.farkop.ru/services/"}>
            <a>Санкт-Петербург</a>
          </Link>
          <Link href={"https://msk.farkop.ru/services/"}>
            <a>Москва</a>
          </Link>
        </div>
      </div>
    </div>
  );
}
